<div class="carousel">
  <div class="carousel-viewport">
    <div 
      class="carousel-track" 
      #carouselTrack
      [style.gap.px]="gap"
    >
      <ng-content></ng-content>
    </div>
  </div>

  <!-- Navigation Controls (Arrows + Dots) -->
  <div class="carousel-navigation" *ngIf="(showArrows || showDots) && totalSlides > 1">
    <button 
      class="carousel-arrow carousel-arrow--prev" 
      *ngIf="showArrows"
      [disabled]="!canGoPrev"
      [class.carousel-arrow--disabled]="!canGoPrev"
      (click)="goToPrev()"
      aria-label="Previous slide"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    
    <!-- Dots Indicator -->
    <div class="carousel-dots" *ngIf="showDots">
      <button
        *ngFor="let i of slidesArray"
        class="carousel-dot"
        [class.carousel-dot--active]="i === currentIndex"
        (click)="goToSlide(i)"
        [attr.aria-label]="'Go to slide ' + (i + 1)"
      ></button>
    </div>
    
    <button 
      class="carousel-arrow carousel-arrow--next" 
      *ngIf="showArrows"
      [disabled]="!canGoNext"
      [class.carousel-arrow--disabled]="!canGoNext"
      (click)="goToNext()"
      aria-label="Next slide"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</div>

